<template>
  <div class="menu_top" style="z-index: 1999">
    <div class="box">
      <div class="img">
        <span>“新华杯”AI审校与写作大赛</span>
        <!-- <span></span> -->
      </div>
      <div class="menu">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
        >
          <!-- 处理普通菜单项和下拉菜单项 -->
          <template v-for="(i, index) in navigationList">
            <!-- 普通菜单项 -->
            <el-menu-item
              v-if="!i.child || i.child.length === 0"
              :key="`menu-${index}`"
              :class="$route.fullPath.indexOf(i.path) !== -1 ? 'active' : ''"
              :index="index.toString()"
              @click="handleMenuItemClick(i)"
            >
              <span>{{ i.name }} <i></i> </span>
            </el-menu-item>
            <!-- 下拉菜单项 -->
            <el-submenu
              v-else
              :key="`submenu-${index}`"
              :index="index.toString()"
            >
              <template slot="title">
                <span>{{ i.name }} <i></i> </span>
              </template>
              <el-menu-item
                v-for="(child, childIndex) in i.child"
                :key="`child-${index}-${childIndex}`"
                :index="`${index}-${childIndex}`"
                @click="handleMenuItemClick(child)"
              >
                {{ child.name }}
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
      <div class="user">
        <!-- <el-popover trigger="hover" v-model="visible">
          <div class="user-news" style="width: 400px; min-height: 300px">
            <div
              v-if="newList.length > 0"
              style="
                display: flex;
                justify-content: space-between;
                line-height: 27px;
                height: 27px;
                border-bottom: 1px solid #ebeef5;
              "
            >
              <div @click="jump('notice')" style="cursor: pointer">
                查看全部>>
              </div>
              <div @click="handleOperation('1')" style="cursor: pointer">
                全部已读
              </div>
            </div>
            <div
              v-if="newList.length > 0"
              style="height: 262px; overflow: auto"
            >
              <div
                v-for="(item, index) in newList"
                :key="index"
                style="
                  line-height: 40px;
                  height: 40px;
                  border-bottom: 1px solid #ebeef5;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <span
                      style="
                        margin-left: 20px;
                        display: inline-block;
                        background: red;
                        border: 1px solid red;
                        border-radius: 50%;
                        height: 5px;
                        width: 5px;
                        margin-right: 8px;
                      "
                    ></span>
                    <div
                      style="
                        width: 200px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        cursor: pointer;
                      "
                      :title="item.subject"
                      @click="view(item.cid, item)"
                    >
                      {{ item.subject }}
                    </div>
                  </div>
                  <span>{{ item.sendTime }}</span>
                </div>
              </div>
            </div>
            <div v-else style="text-align: center; padding-top: 120px">
              暂无数据
            </div>
          </div>
          <span slot="reference" class="ling" @click="newSee">
            <img src="../assets/imgs/lingdang.svg" alt="" />
            <i class="i" v-show="is"></i>
          </span>
        </el-popover> -->
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <i class="el-icon-user-solid">
              <span class="name">{{ username_c }}</span> </i
            ><i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <template>
            <el-dropdown-menu slot="dropdown" v-if="username_c">
              <el-dropdown-item @click.native="jump('information')"
                >用户信息</el-dropdown-item
              >
              <el-dropdown-item @click.native="jump('pass')"
                >修改密码</el-dropdown-item
              >
              <el-dropdown-item @click.native="exit">退出登录</el-dropdown-item>
            </el-dropdown-menu>
            <el-dropdown-menu slot="dropdown" v-else>
              <el-dropdown-item
                @click.native="$router.push({ path: '/login_c', query: { mode: 'login' } })"
                >登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <el-drawer
      title="消息详情"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
      style="z-index: 100"
    >
      <div style="margin-left: 20px">
        <div class="subject-title">{{ content.subject }}</div>
        <div>{{ content.sendTime }}</div>
        <div class="detail-content-box">
        <div class="detail-content" v-html="content.content"></div>
      </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import navigationList from "../tool/navigation.js";
import {
  queryHasRead_c,
  batchMsg_c,
  findByMessageId_c,
} from "../api/interface";
export default {
  data() {
    return {
      navigationList: navigationList.navigationList_c,
      activeIndex: "/layout_c/home",
      username_c: "",
      is: false,
      timer: null,
      visible: false,
      newList: [],
      dialogVisible: false,
      content: "",
      multipleSelection: [],
    };
  },
  created() {
    this.phone_c = localStorage.getItem("phone_c");
    this.email_c = localStorage.getItem("email_c");
    this.username_c = localStorage.getItem("username_c");
    // queryHasRead_c({ userId: localStorage.getItem("userid_c") }).then((res) => {
    //   this.is = res.data;
    // });
    // this.queryHasRead()
    if (localStorage.getItem("userid_c")) {
      // this.timer = setInterval(() => {
      //   queryHasRead_c({ userId: localStorage.getItem("userid_c") }).then(
      //     (res) => {
      //       if (res.status === 200) {
      //         if (res.data.content.length > 0) {
      //           this.is = true;
      //           this.newList = res.data.content;
      //           this.multipleSelection = [];
      //           res.data.content.forEach((item) => {
      //             if (this.multipleSelection.indexOf(item.cid) == -1) {
      //               this.multipleSelection.push(item.cid);
      //             }
      //           });
      //           // console.log(this.multipleSelection);
      //         } else {
      //           this.is = false;
      //           this.newList = [];
      //         }
      //       }
      //     }
      //   );
      // }, 30000);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    queryHasRead(){
      queryHasRead_c({ userId: localStorage.getItem("userid_c") }).then(
          (res) => {
            if (res.status === 200) {
              if (res.data.content.length > 0) {
                this.is = true;
                this.newList = res.data.content;
                this.multipleSelection = [];
                res.data.content.forEach((item) => {
                  if (this.multipleSelection.indexOf(item.cid) == -1) {
                    this.multipleSelection.push(item.cid);
                  }
                })
              }
                // console.log(this.multipleSelection);
              } else {
                this.is = false;
                this.newList = [];
              }
            })
    },
    view(id, content) {
      findByMessageId_c({ cid: id }).then((res) => {
        // this.queryPersonMessage_c(this.parameter);
        console.log(res,'llkjjh')
        if(res.data.status == 'fail'){
          this.$message.error(res.data.message)
        }else{
          this.dialogVisible = true;
          this.content = content;
        }
      });
      // this.queryPersonMessage_c(this.parameter);
    },
    newSee() {
      this.visible = true;
      console.log("显示", this.visible);
    },
    handleSelect(index, indexPath) {
      if (
        this.$route.fullPath !== this.navigationList[Number(indexPath[0])].path
      ) {
        this.$router.push({
          path: this.navigationList[Number(indexPath[0])].path,
        });
      }
    },
    // 处理菜单项点击事件
    handleMenuItemClick(item) {
      if (item.path.startsWith('http://') || item.path.startsWith('https://')) {
        // 外部链接，在新窗口打开
        window.open(item.path, '_blank');
      } else if (item.path) {
        // 判断是否是"我的比赛"菜单项
        if (item.path === '/layout_c/myCompet') {
          // 检查用户是否登录
          const token = localStorage.getItem('token_c');
          if (!token) {
            // 未登录，跳转到登录页面，并携带来源信息
            this.$router.push({
              path: '/login_c',
              query: { 
                mode: 'login',
                redirect: item.path
              }
            });
            return;
          }
        }
        // 已登录或非"我的比赛"菜单项，正常跳转
        this.$router.push({
          path: item.path
        });
      }
    },
    jump(type) {
      console.log(this.$route.query.name);
      if (this.$route.query.name != type) {
        this.$router.push({
          path: "/layout_c/user",
          query: {
            name: type,
          },
        });
      }
    },
    handleOperation(type) {
      let params = {
        ids: [...this.multipleSelection],
        havRead: type,
      };
      batchMsg_c(params).then((res) => {
        if (res.data.status == "SUCCESS") {
          this.$message({
            message: res.data.message,
            duration: 1000,
            showClose: true,
            type: "success",
          });
          // this.queryPersonMessage_c(this.parameter);
        }
      });
    },
    exit() {
      this.$confirm("确定退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          setTimeout(() => {
            localStorage.removeItem("username_c");
            localStorage.removeItem("userid_c");
            localStorage.removeItem("phone_c");
            localStorage.removeItem("email_c");
            localStorage.removeItem("token_c");
            localStorage.removeItem("auditStatus_c");
            localStorage.removeItem("indexOpeneds");
            this.$router.push({
              path: "/login_c",
              query: { mode: "login" }
            });
            this.$message({
              type: "success",
              duration: 1000,
              showClose: true,
              message: "退出成功!",
            });
          }, 300);
        })
        .catch(() => {
          this.$message({
            type: "info",
            duration: 1000,
            showClose: true,
            message: "已取消退出",
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #909399;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
}
.subject-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
}
.detail-content-box {
  width:95%;
.detail-content {
  margin-top: 20px;
  width: 100%;
  /deep/ img{
    width: 100%;
  }
}
}
// .menu_top .menu[data-v-364b72ad] .el-menu
.menu_top {
  text-align: center;
  .box {
    height: 60px;
    display: inline-block;
    width: 1200px;
  }
  position: fixed;
  left: 0;
  right: 0;
  height: 60px;
  // background: rgba(0, 0, 0, 0.8);
  background-color: #3d74fc;
  .img {
    float: left;
    // width: 340px;
    height: 60px;
    padding-top: 15px;
    margin-right: 45px;
    span {
      float: right;
    }
    span:nth-child(2) {
      display: inline-block;
      width: 38px;
      height: 35px;
      background: url("../assets/imgs/tubiao.png") no-repeat;
      background-size: 100% 100%;
    }
    span:nth-child(1) {
      display: inline-block;
      // width: 102px;
      height: 35px;
      line-height: 35px;
      margin: 0 30px 0 10px;
      // background: url("../assets/imgs/xinhuashe.png") no-repeat;
      // background-size: 100% 100%;
      color: #fff;
      font-size: 25px;
      font-weight: 500;
    }
  }
  /deep/.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus {
    background-color: transparent !important;
  }
  .menu {
    float: left;
    height: 60px;
    width: 630px;
    /deep/.el-menu {
      .active {
        span {
          color: #fff !important;
          background-color: transparent;
          i {
            position: relative;
            top: -18px;
            margin: 0 auto;
            display: block;
            width: 100%;
            height: 2px;
            // background: #0067e4;
            background-color: #fff;
          }
        }
      }
      border-bottom: none;
      background: transparent;
      .el-menu-item {
        margin-right: 30px;
        color: #93bef3;
        &:hover {
          background-color: transparent;
          color: #fff;
        }
      }
      .el-submenu {
        margin-right: 30px;
        .el-submenu__title {
          color: #93bef3;
          border-bottom: none;
          &:hover {
            background-color: transparent;
            color: #fff;
          }
          span {
            &:hover {
              color: #fff;
            }
          }
        }
      }
      .is-active {
        border-bottom: none;
      }
      // 下拉菜单样式
      .el-menu--popup {
        background-color: #3d74fc;
        border: none;
        .el-menu-item {
          color: #93bef3;
          margin-right: 0;
          padding: 0 20px;
          height: 40px;
          line-height: 40px;
          &:hover {
            background-color: rgba(255, 255, 255, 0.1);
            color: #fff;
          }
        }
      }
    }
  }

  .user {
    // position: relative;
    float: right;
    height: 60px;
    line-height: 60px;
    .ling {
      position: relative;
    }
    img {
      cursor: pointer;
      width: 17px;
      height: 17px;
      position: relative;
      top: 3px;
      margin-right: 20px;
    }
    .el-dropdown-link {
      cursor: pointer;
      .el-icon-user-solid {
        display: inline-block;
        color: #fff;
        font-size: 17px;
      }
      .name {
        max-width: 120px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 14px;
        display: inline-block;
        margin-left: 5px;
      }
      .el-icon--right {
        color: #fff;
      }
    }
    .i {
      position: absolute;
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #f86b12;
      border-radius: 50%;
      top: 0;
      right: 20px;
    }
  }
}
</style>
